import { Button, Space, message } from 'antd';
import { useDeliveryMessagesSysAdminMutation, usePromoteToDeceasedSysAdminMutation } from 'api/SysAdminApi';

export function QCActions() {
  const [handlePromoteToDeceased, { isLoading: isLoadingDeceased }] = usePromoteToDeceasedSysAdminMutation();
  const [handleDeliveryMessages, { isLoading: isLoadingMessages }] = useDeliveryMessagesSysAdminMutation();
  const [messageApi, contextHolder] = message.useMessage();

  const runPromoteToDeceased = async () => {
    try {
      const result = await handlePromoteToDeceased({}).unwrap();
      const usersPromoted = result?.usersPromoted ?? 0;
      const patientProfilesPromoted = result?.patientProfilesPromoted ?? 0;

      messageApi.success(`Moved ${usersPromoted} users and ${patientProfilesPromoted} patient profiles to deceased.`);
    } catch (e) {
      messageApi.error('Failed to run Move To Deceased. Please try again.');
    }
  };

  return (
    <>
      {contextHolder}
      <h3>QC actions</h3>
      <Space>
        <Button type="primary" loading={isLoadingDeceased} onClick={runPromoteToDeceased}>
          Move To Deceased
        </Button>

        <Button type="primary" loading={isLoadingMessages} onClick={() => handleDeliveryMessages({})}>
          Messages Delivery
        </Button>
      </Space>
    </>
  );
}
